import { BillingPaymentType } from "../enums/global.enums";

export function billingPaymentTypePipe(value: any) {
    switch (value) {
        case BillingPaymentType.Transfer:
            return "Chuyển khoản";
        case BillingPaymentType.Cash:
            return "Tiền mặt";
        case BillingPaymentType.Debtminusdeposit:
            return "Trừ cọc";
        case BillingPaymentType.CollectVNPayQr:
            return "Thu hộ VNPayQr";
        case BillingPaymentType.CollectEmployee:
            return "Thu hộ qua nhân viên";
        default:
            return "";
    }
}